<div class="centrado-horizontal ">
    <p>Sin notificaciones</p>
</div>